import React, { useState, useEffect } from 'react';
import './Challenge.css';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';
const CouponsUsageReport = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [CouponsUsage, setCouponsUsage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const token = localStorage.getItem('auth-token');
  const fetchCouponUsage = async () => {
    setError('')
    setLoading(true);
    const apiEndpoint = process.env.REACT_APP_API_COUPONS_USAGE;
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    try {
      const response = await axios.get(apiEndpoint, { headers });

      if (response.data.success) {
        const transformedCoupons = response.data.data.coupons.map(coupon => ({
          coupon: coupon?.coupon?.couponCode || '-',
          userName: coupon?.user?.name || '-',
          mobileNumber: coupon?.user?.mobile_number || '-',
          usedFor: coupon?.order?.type || '-',
          orderAmount: `${coupon?.order?.amount}` || '-',
          couponDiscount: `${coupon?.order?.discountAmount}` || '-',
        }));

        setCouponsUsage(transformedCoupons);
      } else {
        setError('Failed to load data: No coupons available.');
      }
    } catch (error) {
      setError('Error fetching data: ' + error.message);
      console.error("Error fetching coupons:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCouponUsage();
  }, []);


  const headers = [
    { label: "Coupon", key: "coupon", isNumeric: false },
    { label: "User Name", key: "userName", isNumeric: false },
    { label: "Mobile Number", key: "mobileNumber", isNumeric: false },
    { label: "Used For", key: "usedFor", isNumeric: false },
    { label: "Order Amount", key: "orderAmount", isNumeric: true },
    { label: "Coupon Discount", key: "couponDiscount", isNumeric: true },
  ];

  const [sortConfig, setSortConfig] = useState({
    key: 'coupon',
    direction: 'asc',
    numericKeys: ['orderAmount', 'couponDiscount']
  });

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredCouponsUsage = CouponsUsage.filter((usage) =>
    Object.values(usage)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };


  const sortData = (data) => {
    const { key, direction } = sortConfig;
    return [...data].sort((a, b) => {
      if (key === 'orderAmount' || key === 'couponDiscount') {
        const numA = parseFloat(a[key]) || 0;
        const numB = parseFloat(b[key]) || 0;
        return direction === 'asc' ? numA - numB : numB - numA;
      }


      const valueA = String(a[key] || '').toLowerCase();
      const valueB = String(b[key] || '').toLowerCase();

      if (valueA < valueB) return direction === 'asc' ? -1 : 1;
      if (valueA > valueB) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const sortedCouponsUsage = sortData(filteredCouponsUsage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedCouponsUsage.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedCouponsUsage.length / rowsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = filteredCouponsUsage.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  return (
    <div className="enrollment-container">

      {/* {chartData && chartData.length > 0 && (
        <div>
          <h3>Coupon Discount Distribution</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <YAxis domain={[0, 15000]} />
              <Tooltip />
              <Legend />
              <Bar dataKey="Discount" fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )} */}

      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <CSVLink
          data={filteredCouponsUsage.map(({ mobileNumber, ...rest }) => rest)}
          headers={headers.filter(header => header.key !== 'mobileNumber')}
          filename="CouponUsageReport.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
          <option value={100}>100 items per page</option>
        </select>
        <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchCouponUsage}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredCouponsUsage.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr className="challenges-header-row">
              {headers.map(({ key, label }) => (
                <th
                  key={key}
                  className="challenges-column"
                  onClick={() => handleSort(key)}
                >
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon 
              ${sortConfig.key === key ? 'active' : ''} 
              ${sortConfig.key === key && sortConfig.direction === 'asc' ? 'asc' : ''} 
              ${sortConfig.key === key && sortConfig.direction === 'desc' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((usage) => (
              <tr key={usage.id} className="challenges-row">
                <td className="challenges-cell">{usage.coupon}</td>
                <td className="challenges-cell">{usage.userName}</td>
                <td className="challenges-cell">{usage.mobileNumber}</td>
                <td className="challenges-cell">{usage.usedFor}</td>
                <td className="challenges-cell">{usage.orderAmount}</td>
                <td className="challenges-cell">{usage.couponDiscount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};


export default CouponsUsageReport
